<template>
  <ul class="popup_content">
    <item v-for="item in Items"
               :route="item.route"
               :key="item.index"
               :text="item.text" />
  </ul>
</template>

<script>
export default {
  components: {
    Item: () => import('./DownloadAttachmentDropDownItem')
  },
  data: () => ({
    Items: [
      { route: '', text: 'Download Excel Summary'},
      { route: '', text: 'Download PDF'},
    ],
  }),
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.popup_content {
    display: none;
}
.Invoice_table_popup.active .popup_content {
    display: block;
    position: absolute;
    right: 0;
    width: 240px;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 40px 0 rgba(0,0,0,0.1);
    padding-left: 0;
    list-style-type: none;
    text-align: left;
}
</style>

